/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getQuicksightData } from '../fn/quicksight/get-quicksight-data';
import { GetQuicksightData$Params } from '../fn/quicksight/get-quicksight-data';
import { getQuicksightEmbedUrl } from '../fn/quicksight/get-quicksight-embed-url';
import { GetQuicksightEmbedUrl$Params } from '../fn/quicksight/get-quicksight-embed-url';
import { QuicksightData } from '../models/quicksight-data';

@Injectable({ providedIn: 'root' })
export class QuicksightService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getQuicksightEmbedUrl()` */
  static readonly GetQuicksightEmbedUrlPath = '/api/quicksight/embedUrl';

  /**
   * Get Quicksight Embed Url.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getQuicksightEmbedUrl()` instead.
   *
   * This method doesn't expect any request body.
   */
  getQuicksightEmbedUrl$Response(params?: GetQuicksightEmbedUrl$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return getQuicksightEmbedUrl(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Quicksight Embed Url.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getQuicksightEmbedUrl$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getQuicksightEmbedUrl(params?: GetQuicksightEmbedUrl$Params, context?: HttpContext): Observable<string> {
    return this.getQuicksightEmbedUrl$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `getQuicksightData()` */
  static readonly GetQuicksightDataPath = '/api/quicksight/info';

  /**
   * Get Quicksight Data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getQuicksightData()` instead.
   *
   * This method doesn't expect any request body.
   */
  getQuicksightData$Response(params?: GetQuicksightData$Params, context?: HttpContext): Observable<StrictHttpResponse<QuicksightData>> {
    return getQuicksightData(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Quicksight Data.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getQuicksightData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getQuicksightData(params?: GetQuicksightData$Params, context?: HttpContext): Observable<QuicksightData> {
    return this.getQuicksightData$Response(params, context).pipe(
      map((r: StrictHttpResponse<QuicksightData>): QuicksightData => r.body)
    );
  }

}
